import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import React = require('react');
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { DataManagementAwarenessSettings, DataManagementAwarenessSettingsProps } from './DataManagementAwarenessSettings';
import { DataOrientationProps, DataOrientationSettings } from './dataOrientation/DataOrientationSettings';
import { MarkAnimationProps, MarkAnimationSetting } from './MarkAnimation';
import { StartPageSetting } from './StartPageSetting';
import { WelcomeBanner, WelcomeBannerProps } from './WelcomeBanner';

export interface PreferenceSettingProps {
  startPage: string;
  isViewerSelf: boolean;
  isViewerAdmin: boolean;
  serverUser: IServerUserInfo;
  welcomeChannelEnabled: boolean;
  showPrepConductorAwarenessSetting: boolean;
  showCatalogAwarenessSetting: boolean;
  userHasNoSiteId: boolean;
  siteUser: ISiteUserInfo;
  isServerUserSubplace?: boolean;
  sessionSiteUrlName: string;
}

export function PreferenceSettings(props: PreferenceSettingProps): JSX.Element{
  const startPageSectionProps = {
    startPage: props.startPage,
    isViewerSelf: props.isViewerSelf,
    isViewerAdmin: props.isViewerAdmin,
    sessionSiteUrlName: props.sessionSiteUrlName,
    serverUser: props.serverUser,
  };

  return (
    <>
    <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_Preference_Header()}</h2>
    <table>
      <tbody>
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={2}>
            <StartPageSetting {...startPageSectionProps}/>
          </td>
        </tr>
        {!props.isServerUserSubplace && getSettings(props)}
      </tbody>
    </table>
    </>
  );
}

function getSettings(props: PreferenceSettingProps) {
  const dividerLine = UserSettingsHelper.getSectionDividerLine();
  const shouldShowDataManagementAwarenessSettings = props.isViewerSelf && (props.showPrepConductorAwarenessSetting || props.showCatalogAwarenessSetting);

  return (
    <>
      {dividerLine}
      {getWelcomeSettings(props)}
      {dividerLine}
      {props.isViewerSelf && getAnimationSettings(props)}
      {props.isViewerSelf && dividerLine}
      {props.isViewerSelf && FeatureFlags.dataOrientationSidePaneEnabled && getDataOrientationSettings(props)}
      {props.isViewerSelf && FeatureFlags.dataOrientationSidePaneEnabled && dividerLine}
      {shouldShowDataManagementAwarenessSettings && getDataManagementAwarenessSettings(props)}
      {shouldShowDataManagementAwarenessSettings && dividerLine}
    </>
  );

  function getWelcomeSettings(props: PreferenceSettingProps) {
    const welcomeBannerProps: WelcomeBannerProps = {
      initialValues: {welcomeChannelEnabled: props.welcomeChannelEnabled}
    };

    return insertSettingsTableRow(
      <WelcomeBanner {...welcomeBannerProps} />
    );
  }

  function getAnimationSettings(props: PreferenceSettingProps)
  {
    const markAnimationProps: MarkAnimationProps = {
      userHasNoSiteId: props.userHasNoSiteId,
      siteUser: props.siteUser,
      serverUser: props.serverUser
    };

    return insertSettingsTableRow(
      <MarkAnimationSetting {...markAnimationProps} />
    );
  }

  function getDataOrientationSettings(props: PreferenceSettingProps)
  {
    const dataOrientationProps: DataOrientationProps = {
      userHasNoSiteId: props.userHasNoSiteId,
      siteUser: props.siteUser,
      serverUser: props.serverUser
    };

    return insertSettingsTableRow(
      <DataOrientationSettings {...dataOrientationProps} />
    );
  }

  function getDataManagementAwarenessSettings(props: PreferenceSettingProps) {
    const dataManagementAwarenessSettingsProps: DataManagementAwarenessSettingsProps = {
      siteUser: props.siteUser,
      showPrepConductorCheckbox: props.showPrepConductorAwarenessSetting,
      showCatalogCheckbox: props.showCatalogAwarenessSetting,
    };

    return insertSettingsTableRow(
      <DataManagementAwarenessSettings {...dataManagementAwarenessSettingsProps} />
    );
  }

  function insertSettingsTableRow(settingsData: JSX.Element)
  {
    return (
      <tr>
        <td className={UserSettingsStyle.tbody} colSpan={2}>
          {settingsData}
        </td>
      </tr>
    );
  }
}